import React, { useCallback } from 'react';
import lodashDebounce from 'lodash.debounce';
import { useSelector, RootStateOrAny } from 'react-redux';
import {Wrapper} from './style';

import { appConfig } from 'configs';
import Loader from '../DotLoader';

interface props {
	children?: React.ReactNode,
	debounce?: boolean,
	loading?: boolean,
	onClick?: (event: any) => void,
	disabled?: boolean,
	outline?: boolean,
	className?: string,
	type?: string,
}

const Button: React.FC<props> = ({
	children,
	debounce,
	loading,
	onClick,
	disabled,
	outline,
	className,
	type
}) => {
	const webConfig = useSelector((state: RootStateOrAny) => state?.core);

	const handleClick = useCallback(
		lodashDebounce((event: any) => {
			if (onClick && !loading) onClick(event);
		}, debounce ? appConfig.debounce_delay : 0, { leading: true, trailing: false }),
		[loading, onClick],
	);

	return (
		<Wrapper 
			webConfig={webConfig} 
			isLoading={loading} 
			disabled={disabled} 
			onClick={handleClick}
			className={className}
			type={type}
		>
			{loading ? (
				<div className="loading">
					<Loader color={outline ? '#555' : '#fff'} type="dots" size={8} strokeWidth={2} />
				</div>
			) : null}

			<div className="content">
				{children}
			</div>
		</Wrapper>
	);
};

export default Button;
